import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export const LegacyFutureReadyRedirect = () => {
  const { catalogNumber } = useParams();
  const location = useLocation();
  return <Navigate replace to={`${catalogNumber ? `/job-roles/preview/${catalogNumber}` : '/job-roles'}${location.search}${location.hash}`} />;
};